import { ButtonAction } from '../subcomponents/zoom-controller-buttons';
export const getZoomButtonAvailability = (action, zoomAvailability) => {
    if (action === ButtonAction.ZoomIn || action === ButtonAction.ZoomOut) {
        if (!zoomAvailability)
            return false;
    }
    switch (action) {
        case ButtonAction.ZoomIn:
            return zoomAvailability.in;
        case ButtonAction.ZoomOut:
            return zoomAvailability.out;
        default:
            throw Error(`Unrecognised zoom button action ${action}`);
    }
};
export const getPanButtonAvailability = (action, panAvailability) => {
    if (!panAvailability)
        return false;
    switch (action) {
        case ButtonAction.PanLeft:
            return panAvailability.left;
        case ButtonAction.PanRight:
            return panAvailability.right;
        case ButtonAction.PanUp:
            return panAvailability.up;
        case ButtonAction.PanDown:
            return panAvailability.down;
        default:
            throw Error(`Unrecognised pan button action ${action}`);
    }
};
